import type { DistributorCircuitsTab } from '@/utils/searchParams/parsers';

export type DistributorCircuitsListUrlState = {
  name: string;
  supplierid: string | null;
  country: string | null;
  durationDays: string | null;
  durationNights: string | null;
  circuits: DistributorCircuitsTab;
};

export const buildDistributorCircuitsListSearch = (
  params: DistributorCircuitsListUrlState | null | undefined,
) => {
  if (!params) return '';
  const search = new URLSearchParams();
  if (params.name != null && params.name !== '') {
    search.set('name', params.name);
  }
  if (params.supplierid != null && params.supplierid !== '') {
    search.set('supplierid', params.supplierid);
  }
  if (params.country != null && params.country !== '') {
    search.set('country', params.country);
  }
  if (params.durationDays != null && params.durationDays !== '') {
    search.set('durationDays', params.durationDays);
  }
  if (params.durationNights != null && params.durationNights !== '') {
    search.set('durationNights', params.durationNights);
  }
  if (params.circuits != null) {
    search.set('circuits', params.circuits);
  }
  const str = search.toString();
  return str ? `?${str}` : '';
};
